<template>
  <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab-4">
<!--    Import templates modal-->
    <construction-templates-modal/>
<!--    Save Construction Report-->
    <save-construction-template/>

    <div class="form-row">
      <div class="col-md-12">
        <div class="innerbox pb-2">
          <h2>Bautagebuch
            <span class="float-right">
              <a class="settingbuttons" data-toggle="modal" data-target="#constructionTemplateModal" v-if="fieldsGroups.length < 1">
                Vorlage wählen
              </a>
              <a class="settingbuttons" data-toggle="modal" data-target="#save-c-TemplateModal">
                Vorlage speichern
              </a>
            </span>
          </h2>
          <div class="inrbox pb-0">
            <div class="col-xl-12 col-lg-12 col-md-12 main-tabs tb-innr pl-0">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link active" id="tabb-1" data-toggle="tab" href="#tabb1" role="tab" aria-controls="tabb1" aria-selected="true">Allgemein</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="tabb-4" data-toggle="tab" href="#tabb4" role="tab" aria-controls="tabb4" aria-selected="false">Wetter</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="tabb-2" data-toggle="tab" href="#tabb2" role="tab" aria-controls="tabb2" aria-selected="false">Personal</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="tabb-3" data-toggle="tab" href="#tabb3" role="tab" aria-controls="tabb3" aria-selected="false">Felder</a>
                </li>
              </ul>
              <div class="tab-content tabc-inner screen-height app-settigs-weather">
                <div class="tab-pane fade show active" id="tabb1" role="tabpanel" aria-labelledby="tabb-1">
                  <div class="form-row mb-3">
                    <label class="col-sm-2 pt-2">
                      <strong>Bautagebuch aktivieren</strong>
                    </label>
                    <div class="col-sm-6">
                      <div class="switch new">
                        <label class=" ml-2">
                          <input type="checkbox" v-model="$store.state.appSettings.project.constructionreport">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <label class="col-sm-12 pl-0">
                    <strong>Kopfzeile</strong>
                  </label>
                  <div class="form-row mb-1 pl-4">
                    <label class="col-sm-2 pt-2">
                      <strong>Projektnummer</strong>
                    </label>
                    <div class="col-sm-6">
                      <div class="switch new">
                        <label>
                          <input type="checkbox" v-model="show_projectnumber">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mb-1 pl-4">
                    <label class="col-sm-2">
                      <strong>Bauherr</strong>
                    </label>
                    <div class="col-sm-6">
                      <div class="switch new">
                        <label>
                          <input type="checkbox" v-model="show_constructor">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mb-1 pl-4">
                    <label class="col-sm-2">
                      <strong>Ersteller</strong>
                    </label>
                    <div class="col-sm-6">
                      <div class="switch new">
                        <label>
                          <input type="checkbox" v-model="show_creator">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                    </div>
                  </div>
<!--                 Second part started here-->
                  <label class="col-sm-12 pl-0">
                    <strong>Fußzeile</strong>
                  </label>
                  <div class="form-row mb-1 pl-4">
                    <label class="col-sm-2 pt-2">
                      <strong>Erstellt durch</strong>
                    </label>
                    <div class="col-sm-7">
                      <div class="switch new d-inline-block">
                        <label>
                          <input type="checkbox" v-model="left_footer">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                      <div class="mb-2 d-inline-block ml-3">
                        <div class="check-sides-box border  rounded">
                          <div class="left-box border-right d-inline-block" :class="{active: left_footer_creator}" @click="footerLeftCreatorClick">Ersteller anzeigen</div>
                          <div class="right-box d-inline-block" :class="{active: left_footer_text}" @click="footerLeftTextClick">Eigener Text</div>
                        </div>
                      </div>
                      <div class="mb-2 d-inline-block ml-3">
                        <input type="text" class="form-control-sm form-control" v-model="left_footer_text_input">
                      </div>
                    </div>
                  </div>
                  <div class="form-row mb-1 pl-4">
                    <label class="col-sm-2">
                      <strong>Geprüft AN</strong>
                    </label>
                    <div class="col-sm-6">
                      <div class="switch new d-inline-block">
                        <label>
                          <input type="checkbox" v-model="center_footer">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                      <div class="mb-2 d-inline-block ml-3">
                        <input type="text" class="form-control-sm form-control" v-model="center_footer_text">
                      </div>
                    </div>
                  </div>
                  <div class="form-row mb-1 pl-4">
                    <label class="col-sm-2">
                      <strong>Gesehen AG</strong>
                    </label>
                    <div class="col-sm-6">
                      <div class="switch new d-inline-block">
                        <label>
                          <input type="checkbox" v-model="right_footer">
                          <span class="lever mr-0"></span>
                        </label>
                      </div>
                      <div class="mb-2 d-inline-block ml-3">
                        <input type="text" class="form-control-sm form-control" v-model="right_footer_text">
                      </div>
                    </div>
                  </div>

                </div>
                <!--                Personal Tab  / Staff -->
                <div class="tab-pane fade" id="tabb2" role="tabpanel" aria-labelledby="tabb-2">

                  <table class="table table-sm">
                    <thead>
                    <tr>
                      <th scope="col">Schicht</th>
                      <th scope="col">Personaltyp</th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody v-for="(shift,index) in project.shifts" :key="index">
                    <tr @click="activateGroup($event , index)" :class="{'active_tr': activeGroup === index}">
                      <td colspan="4">
                        <div class="form-row">
                          <strong class="text-capitalize col-md-8">
                            <i class="fa fa-circle dot-color pt-1 pr-2"></i>
                            <span v-if="activeGroup === index">
                              <input type="text" v-model="shift.crshiftname" placeholder="Schichtname" class="form-control w-25 input-style d-inline mr-3" :id="activeGroup ? 'focus-input' : ''">
                              Start:   <input type="time" class="form-control w-25 input-style mr-3 d-inline" v-model="shift.start">
                              End:   <input type="time" class="form-control w-25 input-style d-inline" v-model="shift.end">
                              <span  data-value="btn"  class="udrem position-absolute" @click="removeShift(index)" style="right: -25px;top: 1px">
                                  <img src="@/assets/images/delete_icon.png" alt="remove" width="23">
                              </span>
                            </span>
                            <span v-else class="font1rem">  {{shift.crshiftname || 'Schichtname'}}  ( {{shift.start }} - {{shift.end}} ) </span>
                          </strong>
                        </div>
                      </td>
                    </tr>

                    <tr v-for="(type , i) in shift.stafftypes" :class="{active_tr: `${i}${index}` === activeIndex}" :key="i"  @click="makeFieldsEditable($event,`${i}${index}`)">
                      <th scope="row"></th>
                      <td>
                        <div class="form-row">
                          <div class="col-auto">
                            <div class="custom-control custom-checkbox circle-checkbox">
                              <i class="fa fa-circle dot-color pt-1"></i>
                            </div>
                          </div>
                          <div class="col-auto">
                            <input type="text" v-if="`${i}${index}` === activeIndex" v-model="type.stafftypename" class="form-control input-style">
                            <span v-else class="font1rem"> {{ type.stafftypename }} </span>
                          </div>
                        </div>

                      </td>
                      <td style="z-index: 999;">
                        <div class="udarrow" data-value="btn" v-visible="`${i}${index}` === activeIndex">
                          <small data-value="btn" @click="moveDown(i,shift,index)" v-if="i">
                            <img src="@/assets/images/up_icon.png" alt="remove" width="25">
                          </small>
                          <small data-value="btn" @click="moveUp(i,shift,index)" v-if="shift.stafftypes.length !== (i + 1)">
                            <img src="@/assets/images/down_icon.png" alt="remove" width="25">
                          </small>
                        </div>
                        <a href="javascript:void(0)" data-value="btn" v-visible="`${i}${index}` === activeIndex" class="udrem" @click="removeType(i,shift)">
                          <img src="@/assets/images/delete_icon.png" alt="remove" width="23">
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td colspan="3">
                        <a class="settingbuttons"  @click="addNewType(shift)">
                          <i class="fa fa-plus pr-1" aria-hidden="true"></i>
                          Typ hinzufügen
                        </a>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                      <td colspan="4">
                        <a class="settingbuttons" @click="addNewShift">
                          <i class="fa fa-plus pr-1"></i>   Schicht hinzufügen
                        </a>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
                <!--                Filder Tab-->
                <settings-fields-tab/>
                <div class="tab-pane fade" id="tabb4" role="tabpanel" aria-labelledby="tabb-4">
                  <div class="col-md-12 p-0">
                    <div class="form-row mb-3">
                      <h4>Wetterdaten</h4>
                    </div>
                    <div class="form-row mb-3">
                      <label class="col-sm-2 pt-2"><b>Wetterdienst aktivieren</b></label>
                      <div class="col-sm-1">
                        <div class="switch new">
                          <label class="w-100">
                            <input type="checkbox" v-model="project.use_weatherdb">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-auto">
                        <a href="#" class="wetterlink mt-2">wetter.com</a>
                      </div>
                    </div>
                    <form @submit.prevent="getWeatherReport">
                      <div class="form-row mb-3">

                        <label for="qry" class="col-sm-12 pt-2"><b>Wetter-Code suchen</b></label>
                        <div class="col-auto">
                          <input type="text" id="qry" v-model="search_string" class="form-control input-style m-0"  required>
                        </div>
                        <div class="col-auto">
                          <button class="btn btn-white p-225">Suchen</button>
                        </div>
                        <div class="col-auto pl-4" style="min-width: 30%">
                          <select class="form-control" v-if="weatherReports.result" v-model="weatherReport" v-on:change="setWeaterReport">
                            <option v-for="report in weatherReports.result" :value="report">
                              {{report.name}} , {{report.country}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </form>
                    <div class="form-row">
                      <label class="col-sm-12 pt-2"><b>Aktuelle Wetterdaten:</b></label>
                      <div class="col-sm-6 row">
                        <div class="col-md-3">Land :</div>
                        <div class="col-md-9">
                          {{project.weathercountry}}
                        </div>
                        <div class="col-md-3">PLZ :</div>
                        <div class="col-md-9">
                          {{project.weatherzipcode}}
                        </div>
                        <div class="col-md-3">Ort :</div>
                        <div class="col-md-9">
                          {{project.weathercity}}
                        </div>
                        <div class="col-md-3 pt-2 pr-0">CityCode :</div>
                        <div class="col-md-9 pt-2">
                          {{project.weathercitycode}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dokubtns text-right pt-2">
            <span class="btninner">
              <button type="button" class="btn btn-danger" data-dismiss="modal"  @click="$router.push({name: 'photo', params: {id: $route.params.id}})">
                {{ $t('cancel')}}
              </button>
              <button type="button"  @click="saveProjectDetails"  class="btn btn-blue mr-1">
                {{$t('save')}}
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SettingsFieldsTab from './SettingsFieldsTab'
import ConstructionTemplatesModal from './ConstructionTemplatesModal'
import SaveConstructionTemplate from './SaveConstructionTemplate'
export default {
  name: 'constructionDiary',
  data(){
    return {
      search_string : '',
      weatherReport: {},
      activeIndex : null,
      activeGroup: null,
      cr_params: {
        left_footer: true,
        right_footer: true,
        center_footer: true,
        show_creator: true,
        show_constructor: true,
        show_projectnumber: true
      }
    }
  },
  components: {
    SettingsFieldsTab,
    ConstructionTemplatesModal,
    SaveConstructionTemplate
  },
  computed : {
    project(){
      return this.$store.state.appSettings.project || {}
    },
    left_footer: {
      get: function() {
        if(this.$store.state.appSettings.project.cr_params.left_footer == '%currentuser%') {
          return true
        }
        if(this.$store.state.appSettings.project.cr_params.left_footer != false) {
          return true
        }
        return false
      },
      set: function(newValue) {
        this.$store.state.appSettings.project.cr_params.left_footer = newValue
      }
    },
    left_footer_creator() {
      if(this.$store.state.appSettings.project.cr_params.left_footer == '%currentuser%') {
        return true
      }
      return false
    },
    left_footer_text() {
      if(this.$store.state.appSettings.project.cr_params.left_footer != true && this.$store.state.appSettings.project.cr_params.left_footer != false) {
        if(this.$store.state.appSettings.project.cr_params.left_footer == '%currentuser%') {
          return false
        }
        return true
      }
      return false
    },
    left_footer_text_input: {
      get() {
        if(this.$store.state.appSettings.project.cr_params.left_footer != true && this.$store.state.appSettings.project.cr_params.left_footer != false) {
          if(this.$store.state.appSettings.project.cr_params.left_footer != '%currentuser%') {
            return this.$store.state.appSettings.project.cr_params.left_footer
          }
        }
        return ''
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.left_footer = newValue
      }
    },
    show_projectnumber: {
      get() {
        return this.$store.state.appSettings.project.cr_params.show_projectnumber || false
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.show_projectnumber = newValue
      }
    },
    show_constructor: {
      get() {
        return this.$store.state.appSettings.project.cr_params.show_constructor || false
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.show_constructor = newValue
      }
    },
    show_creator: {
      get() {
        return this.$store.state.appSettings.project.cr_params.show_creator || false
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.show_creator = newValue
      }
    },



    center_footer: {
      get() {
        if(this.$store.state.appSettings.project.cr_params.center_footer != false) {
          return true
        }
        return false
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.center_footer = newValue
      }
    },
    center_footer_text: {
      get() {
        if(typeof this.$store.state.appSettings.project.cr_params.center_footer === "boolean") {
          return '';
        }
        return this.$store.state.appSettings.project.cr_params.center_footer
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.center_footer = newValue
      }
    },
    right_footer: {
      get() {
        if(this.$store.state.appSettings.project.cr_params.right_footer != false) {
          return true
        }
        return false
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.right_footer = newValue
      }
    },
    right_footer_text: {
      get() {
        if(typeof this.$store.state.appSettings.project.cr_params.right_footer === "boolean") {
          return '';
        }
        return this.$store.state.appSettings.project.cr_params.right_footer
      },
      set(newValue) {
        this.$store.state.appSettings.project.cr_params.right_footer = newValue
      }
    },
    weather(){
      return this.$store.state.appSettings.cityWeather
    },
    weatherReports(){
      return this.$store.state.appSettings.weatherReports
    },
    fieldsGroups(){
      return this.$store.state.appSettings.fieldsGroups
    }
  },
  created () {
    this.$store.dispatch("getFieldsGroupData",this.$route.params.id);
  },

  methods : {

    footerLeftCreatorClick() {
      this.$store.state.appSettings.project.cr_params.left_footer = '%currentuser%'
    },
    footerLeftTextClick() {
      this.$store.state.appSettings.project.cr_params.left_footer = ''
    },

    async saveProjectDetails(){
      await this.$store.dispatch('updateProjectDetails');
      await this.$router.push({name: 'photo', params: {id: this.$route.params.id}});
  },


    /**
     * Add New Shift
     */
    addNewShift(){
      let item = {
        crshiftid: 0,
        crshiftname: "",
        crshiftorder: 0,
        end: "16:00",
        stafftypes: [],
        start: "06:00",
        _explicitType: "com\\projectdocu\\CRShiftVO"
      }

      this.addNewType(item);
      this.project.shifts.push(item);
      this.activeGroup = (this.project.shifts.length - 1)
      setTimeout(function (){
        if (document.getElementById('focus-input')){
          document.getElementById('focus-input').focus()
        }
      },200)
    },

    removeShift(index) {
      this.project.shifts.splice(index,1);
    },


    async getWeatherReport(){
      await this.$store.dispatch("getCityWeather",this.search_string);
    },

    addNewType(type){
      let item = {
        crstafftypeorder: 0,
        stafftypename: "Neu",
        workingvalues: Array(0),
        _explicitType: "com\\projectdocu\\CRStaffTypeVO"
      }
      type.stafftypes.push(item)
    },

    setWeaterReport(val){
      this.$store.commit('setCityWeather',this.weatherReport)
    },


    //Move the fields down by clicking the down arrow
    moveDown(from,shift,index){
      let to = from - 1;
      this.activeIndex = `${to}${index}`
      this.moveIndex(shift,from , to)
    },

    //Move the fields down by clicking the down arrow
    moveUp(from,shift,index){
      let to = from + 1;
      this.moveIndex(shift,from , to)
      this.activeIndex = `${to}${index}`
    },
    //remove type
    removeType(index,shift){
      shift.stafftypes.splice(index,1)
    },

    moveIndex(shift,from, to) {
      let numberOfDeletedElm = 1;
      const elm = shift.stafftypes.splice(from, numberOfDeletedElm)[0];
      numberOfDeletedElm = 0;
      shift.stafftypes.splice(to, numberOfDeletedElm, elm);
    },

    makeFieldsEditable(e,index){
      let element = e.target.getAttribute('data-value');
      let tag = e.target.tagName;
      if(element !== "btn" && tag !== 'IMG' && tag !== 'INPUT'){
        this.activeIndex =  index === this.activeIndex ? null : index;
        this.activeGroup = null;
      }
    },

    activateGroup(e, index){
      if (e.target.tagName !== 'INPUT'){
        this.activeGroup = index === this.activeGroup ? null : index
      }
    }
  }
}
</script>

<style scoped>
.active_tr{
  background: lightgray;
}
.btnw,.udarrow small,.udrem{
  cursor: pointer;
  z-index: 1000;
  font-size: 1rem;
}
div.app-settigs-weather{
  height: calc(100vh - 271px);
}
.input-text-cons{
  width: 100px;
  height: 38px;
  border: 1px solid black;
  border-radius: 5px;
}
.check-sides-box div{
  padding: 7px 10px;
  font-size: 12px;
  cursor: pointer;
}
.check-sides-box div.active{
  background: #3399FF;
  color: white;
}
#tab4 .d-inline-block input.form-control-sm{
  width: 215px;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/ConstructionDiary.vue